
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
//import {Row, Col, Container, Card} from 'react-bootstrap';
import { Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';


// import Select from 'react-select';

const Subject = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [dropdowns, setDropdowns] = useState({ premTypes: [], mainComp: [] });
  const [ddlSub, setDdlSub] = useState ([]);

  // Header State
  // const [headerData, setHeaderData] = useState({
  //   year1: '',
  // });

  const [savedfromDate, setSavedFromDate] = useState('');
  const [savedendDate, setSavedEndDate] = useState('');
  const [savedYear1, setSavedYear1] = useState('');

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      sub_type_desc: '',
      sub_type_id: '',

    }
  ]);

  // const handleHeaderChange = (e) => {
  //   const { name, value } = e.target;
  //   setHeaderData(prev => ({ ...prev, [name]: value }));
  // };

  const handleChildChange = (index, e) => {
    const { name, value } = e.target;
    const updatedRows = [...childRows];
    updatedRows[index][name] = value;
    setChildRows(updatedRows);
  };


  useEffect(() => {
    const fetchLists = async () => {
      try {
        const subresult = await axios.get(`${BASE_URL}/api/ddl_sub_type`);
      setDdlSub(subresult.data);
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };
    fetchLists();
  }, []);

  const addRow = () => {
    const newIndex = childRows.length + 1; // 1-based index
    const newRow = {
      parent_irn: '',
      maintId: '',
      dispOrder: newIndex, // Default to index + 1
      amount: ''
    };
    setChildRows([...childRows, newRow]);
    //setChildRows([...childRows, { parent_irn: '', maintId: '', dispOrder: '', amount: '' }]);
  };

  const removeRow = (index) => {
    const updatedRows = [...childRows];
    updatedRows.splice(index, 1);
    setChildRows(updatedRows);
  };

  const handleNew = () => {
    setIsEditable(true);
    setChildRows([{
      sub_type_desc: '',
      sub_type_id: '',
    }]);
  };

  const handleSave = async () => {

    // if (!headerData.fromDate || !headerData.toDate) {
    //   //speakMessage('From or To Date cannot be left blank.');
    //   alert('From or To Date cannot be left blank !');
    //   return;
    // }
    // else if (headerData.fromDate > headerData.toDate) {
    //   //speakMessage('From cannot be greater than To Date.');
    //   alert('From cannot be greater than To Date !');
    //   return;
    // }
    // else if (!headerData.premiseType || headerData.premiseType === '') {
    //   //speakMessage('Please Select Premise Type');
    //   alert('Please Select Premise Type !');
    //   return;
    // }

    let lv_err_msg = '';

    for (let i = 0; i < childRows.length; i++) {
      if (!childRows[i].maintId || childRows[i].maintId === '') {
        lv_err_msg = 'Please Select Maintenance Component at Row # ' + (i + 1);
        break;
      }
      else if (!childRows[i].dispOrder || childRows[i].maintId === '0') {
        lv_err_msg = 'Please enter Display Order at Row # ' + (i + 1);
        break;


      }
      else if (!childRows[i].amount || childRows[i].amount === '0' || childRows[i].amount < 0) {
        lv_err_msg = 'Please enter Maintenance Amount greater than 0 at Row # ' + (i + 1);
        break;
      }

    }

    if (lv_err_msg) {
      alert(lv_err_msg);
      return;
    }

    let lv_dupl = 0;

    for (let i = 0; i < childRows.length; i++) {
      for (let j = i + 1; j < childRows.length; j++) {
        if (childRows[i].maintId === childRows[j].maintId) {
          lv_dupl = j;
          break;
        }
      }
      if (lv_dupl > 0) {
        break;
      }
    }

    if (lv_dupl > 0) {
      playBeep();
      alert('Duplicate Maintenance Component selected at Row # ' + (lv_dupl + 1));
      return;
    }

    // DB Validation to check if the given From/To dates, Premise Type already exists or not
   // console.log('valResp.data ===> ', valResp.data); 
    // console.log('valResp.data[0].rows_count ===> ', valResp.data[0].rows_count); 

    const isConfirmed = window.confirm("Sure you want to Save the record ?");

    if (!isConfirmed) return;

    const structdata = {
      // header: headerData,
      details: childRows,
    };

    const response = await axios.post(`${BASE_URL}/api/save_maint_struct`, structdata);

  };

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      handleNew();
      setIsEditable(false);
    }
  };

  const playBeep = () => {
    const audioCtx = new (window.AudioContext || window.AudioContext)();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    oscillator.type = 'square'; // Other types: sine, square, triangle, sawtooth
    oscillator.frequency.setValueAtTime(440, audioCtx.currentTime); // Frequency in Hz (440Hz = A4 note)
    gainNode.gain.setValueAtTime(0.1, audioCtx.currentTime); // Volume

    oscillator.start();
    oscillator.stop(audioCtx.currentTime + 0.2); // Play for 0.2 seconds
  };

  const speakMessage = (message) => {
    const utterance = new SpeechSynthesisUtterance(message);
    utterance.lang = 'en-US'; // or 'en-GB', 'hi-IN', etc.
    utterance.rate = 1;       // Speed: 0.1 (slow) to 10 (fast)
    utterance.pitch = 1;      // Pitch: 0 to 2
    speechSynthesis.speak(utterance);
  };

  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">

        {/* {<Row className="mb-3">

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "100px" }}>
                Year
              </InputGroup.Text>
              <select
                className="form-select"
                name="year1"
                value={headerData.year1}
                disabled={!isEditable}
              // onChange={handleChange}
              >
                <option value="">-- Select Year--</option>
                <option value=""></option>

              </select>
            </InputGroup>
          </Col>
          </Row>} */}

        <div className="d-flex justify-content-end gap-1 flex-wrap">

          <button
            type="button"
            className="btn btn-primary"
            style={{ width: "135px" }}
            onClick={handleNew}
            disabled={isEditable}
          >New
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            style={{ width: "135px" }}
            onClick={handleClear}
          > Clear
          </button>

          <button
            type="button"
            className="btn btn-success"
            style={{ width: "135px" }}
            onClick={handleSave}
            disabled={!isEditable}
          > Save
          </button>
        </div>

      </Card>

      {/* Child Table */}
      <Card className="p-3">
        {/* <h5>Maintenance Items</h5> */}
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: '2%', textAlign: 'center' }}>#</th>
                <th style={{ width: '15%', textAlign: 'left' }}>Subject Description</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Subject Type</th>
                <th style={{ width: '5%', textAlign: 'left' }}></th>
              </tr>
            </thead>

            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td>
                    <input style={{ textAlign: 'left' }} disabled={!isEditable}
                      type="text" className="form-control" name="sub_type_desc" value={row.sub_type_desc} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <select className="form-select" disabled={!isEditable}
                      name="sub_type_id" value={row.sub_type_id} onChange={(e) => handleChildChange(index, e)}>
                      <option value="0">-- Select Subject --</option>
                      {ddlSub.map(sub => (
                  <option key={sub.sub_type_id} value={sub.sub_type_id}>{sub.sub_type_desc}</option>
                ))}
                    </select>
                  </td>

                  <td style={{ textAlign: 'center' }}>
                    {childRows.length > 1 && (
                      <Button variant="danger" onClick={() => removeRow(index)} size="sm">Delete</Button>
                    )}
                  </td>
                 </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mb-3">
          <Button disabled={!isEditable} style={{ marginTop: '10px' }} variant="primary" onClick={addRow}>Add Row</Button>
        </div>
      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default Subject;
